import { render, staticRenderFns } from "./CalendarioAdmin.vue?vue&type=template&id=5492bd76&scoped=true&"
import script from "./CalendarioAdmin.vue?vue&type=script&lang=js&"
export * from "./CalendarioAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CalendarioAdmin.vue?vue&type=style&index=0&id=5492bd76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5492bd76",
  null
  
)

export default component.exports